import React from 'react';
import './list.css';

export interface IHeader {
  className: string;
  column: string | number;
  text: string;
}

export interface IListProps {
  header: Array<IHeader>;
  data: Array<any>;
  listCustom: (container: any, i: number, data: Array<any>) => void;
  noData: 'Sem informação';
  cy: string;
}

export const List = ({
  header,
  data,
  listCustom = () => null,
  noData = 'Sem informação',
  cy = '',
}: IListProps) => {
  return (
    <div className="box-scrool">
      <table className="list-box" data-cy={`Table${cy}`}>
        <thead>
          <tr data-cy={`Table${cy}Header`}>
            {header.map((header: IHeader) => {
              return (
                <td
                  className={header.className}
                  key={header.column}
                  data-cy={`Table${cy}HeaderColumn[${header.column}]`}
                >
                  {header.text}
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.length ? (
            data.map((container: any, i: number) => {
              listCustom(container, i, data);
              return (
                <tr
                  key={container.id ? container.id : i}
                  data-cy={`Table${cy}Row[${i}]`}
                >
                  {header.map((header: IHeader) => {
                    return (
                      <td
                        className={header.className}
                        key={`${container.id ? container.id : i}-${
                          header.column
                        }`}
                        data-cy={`Table${cy}Row[${i}]Column[${header.column}]`}
                      >
                        {container[header.column] !== undefined &&
                        container[header.column] !== 'undefined (undefined %)'
                          ? container[header.column]
                          : 0}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan={header.length}
                className="text-center"
                data-cy={`Table${cy}NoData`}
              >
                {noData}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
